import { Chip } from '@mui/material';
import { styled } from '@mui/material/styles';

// Get status color for UI display
export const getStatusColor = (status: string | null | undefined, theme?: any) => {
  if (!status) return 'default';
  switch (status) {
    case 'healthy': return theme ? theme.palette.success.main : '#4caf50';
    case 'sick': return theme ? theme.palette.error.main : '#f44336';
    case 'treatment': return theme ? theme.palette.warning.main : '#ff9800';
    case 'quarantined': return theme ? (theme.palette.purple ? theme.palette.purple.main : '#9c27b0') : '#9c27b0';
    case 'pregnant': return theme ? theme.palette.info.main : '#2196f3';
    case 'recovering': return theme ? (theme.palette.teal ? theme.palette.teal.main : '#009688') : '#009688';
    case 'lactating': return theme ? theme.palette.warning.light : '#fff176';
    case 'growing': return theme ? theme.palette.success.light : '#8bc34a';
    case 'mature': return theme ? theme.palette.info.light : '#4dd0e1';
    case 'culled': return '#795548'; // brown
    case 'sold': return '#607d8b'; // blueGrey
    case 'deceased': return '#212121'; // almost black
    default: return theme ? theme.palette.grey[500] : '#bdbdbd';
  }
};

// Custom styled StatusChip component
const StatusChip = styled(Chip)<{ status: string }>(({ theme, status }) => {
  const color = getStatusColor(status, theme);
  return {
    backgroundColor: color,
    color: theme.palette.getContrastText(color),
    fontWeight: 500,
    textTransform: 'capitalize',
  };
});

export default StatusChip;
